import React from 'react';
import './NavBarPlayList.scss';
import { Link } from 'react-router-dom';

PlayListTracks.propTypes = {

};

function PlayListTracks(props) {
    return (
        <div className="nav-bar__play-list__item">
            <Link to="/collection/tracks" className="nav-bar__play-list_tracks" draggable="false">
                <svg role="img" height="16" width="16" viewBox="-3 -3 22 22" className="nav-bar__play-list__item__icon nav-bar__play-list__item__icon-play-list">
                    <path fill="none" d="M0 0h16v16H0z"></path>
                    <path fill="#fff" d="M13.797 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253c-.77.77-1.194 1.794-1.194 2.883s.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195a4.052 4.052 0 001.195-2.883 4.057 4.057 0 00-1.196-2.883z"></path>
                </svg>
                <span className="nav-bar__play-list__item__title" as="span">Liked Songs</span>
            </Link>
        </div>
    );
}

export default PlayListTracks;